<app-base-send-queue
  [getTableDataApiMethodName]="getTableDataApiMethodName"
  [pageTitle]="pageTitle"
  pageId="app-current-user-send-queue"
  [pageTagName]="tagName"
  [tabName]="tabName"
>
</app-base-send-queue>
